module.exports = __webpack_public_path__ + "static/media/ned-flanders.90decb36.jpg";